import { Component, effect, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Router } from '@angular/router';
import { AuthService } from '../../core/services/auth/auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatButtonModule, MatProgressSpinnerModule],
})
export class LoginComponent {
  public authService = inject(AuthService);
  private router = inject(Router);

  constructor() {
    // Auto-forward if already authenticated once checks are done
    effect(() => {
      if (
        this.authService.authCheckedSig() &&
        this.authService.isAuthenticatedSig() &&
        this.authService.isAuthorizedSig()
      ) {
        this.router.navigateByUrl('/releases', { replaceUrl: true });
      } else if (
        this.authService.authCheckedSig() &&
        this.authService.isAuthenticatedSig() &&
        !this.authService.isAuthorizedSig()
      ) {
        this.router.navigateByUrl('/unauthorized', { replaceUrl: true });
      }
    });
  }

  login(): void {
    this.authService.login();
  }
}
